export default "__VITE_ASSET__BR_kwGAY__"